import { Hotspot } from './Hotspot';

export class Minimap {
  constructor(data = {}) {
    const {
      created_at,
      createdAt = created_at,
      staticNorth,
      floor_id,
      floorId = floor_id,
      id,
      image_2dmap,
      image2dmap = image_2dmap,
      image_3dmap,
      image3dmap = image_3dmap,
      image_id,
      imageId = image_id,
      name,
      project_id,
      projectId = project_id,
      type,
      unit_type_id,
      unitTypeId = unit_type_id,
      updated_at,
      updatedAt = updated_at,
      user_id,
      userId = user_id,
      view_id,
      viewId = view_id,
      hotspots = [],
      northAngle, // optional, for exterior minimap support
    } = data;

    Object.assign(this, {
      createdAt,
      floorId,
      id,
      image2dmap,
      staticNorth,
      image3dmap,
      imageId,
      name,
      projectId,
      type,
      unitTypeId,
      updatedAt,
      userId,
      viewId,
      northAngle,
      hotspots: hotspots.map(data => new Hotspot(data)),
    });
  }
}
